$.fn.downloadCenterFilter = function (options) {
    var defaults = {
      allValue: 'all',
      hidefileClass: 'files-list__item--hide',
      files: '[data-filter="element"]',
      filters: '[data-filter="filter"]'
    };
    var o = $.extend({}, defaults, options);
    var filters = $(o.filters);
    var files = $(o.files);

      // nabindujeme sledování kliknutí na položku filteru
      $("input", o.filters).on('change', function() {
        var fVal = $(this).val();
        files.removeClass(o.hidefileClass);
        // Projdeme všechny prvky v proměnné "contacts"
        files.each(function() {
            var file = $(this);
            var lang = file.data("lang");
            if (fVal === o.allValue) {
                file.removeClass(o.hidefileClass);
            } else {
                // Pokud prvek nemá data atribut odpovídající hodnotě radio buttonu, přidáme třídu "hide"
                if (fVal != lang) {
                    file.addClass(o.hidefileClass);
                }
            }
        });
      });
  };


// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/third/jquery.downloadCenterFilter.js